import type {
  FacetItem,
  SearchFacetType,
  SearchVideosQueryVariables,
  SearchVideoUrlQuery,
  SearchVideoUrlQueryForMetaTitle,
} from "~/components/blocks/vod/list/types";
import { CATEGORY_IDS } from "~/const/categories";
import type { ListSearchQuery } from "~/const/hrefs";
import { G_VideoSearchSortKey } from "~/lib/graphql";

/**
 * 作品一覧の左ナビや絞り込みモーダルで表示する「見出し名」と「並び順」を管理する定数オブジェクト
 */
export const SEARCH_FACET_TITLES = {
  viewingTypes: "視聴形式",
  categories: "カテゴリ",
  genres: "ジャンル",
  campaigns: "キャンペーン",
  series: "シリーズ",
  casts: "出演者",
  staffs: "スタッフ",
  // TODO(uchida): 表示時の条件を確認
  // titles: "タイトル",
  contentTypes: "2D / VR",
} as { readonly [K in SearchFacetType]: string };

export const GRAVURE_SEARCH_FACET_TITLES = {
  viewingTypes: "視聴形式",
  genres: "ジャンル",
  campaigns: "キャンペーン",
  series: "シリーズ",
  casts: "出演者",
  staffs: "メーカー",
  contentTypes: "2D / VR",
} as { readonly [K in SearchFacetType]: string };

export const SEARCH_SORT_NAME_MAP = {
  [G_VideoSearchSortKey.Rank]: "人気順",
  [G_VideoSearchSortKey.New]: "新着順",
} as { readonly [K in G_VideoSearchSortKey]: string };

/**
 * !!!!CAUTION!!!!
 *
 * ここのキーの並び順は`/vod/list/`でのURLクエリでの並び順を指定しており、
 * SEOの変更時以外は並び順を変更しないこと
 */
export const VOD_LIST_URL_QUERY_KEYS_ORDER: ReadonlyArray<keyof ListSearchQuery> = [
  "categories",
  "genres",
  "series",
  "casts",
  "staffs",
  "campaigns",
  "content_types",
  "viewing_types",
  "title",
  "keyword",
  "sort",
  "cursor",
  "season",
  "content",
];

/**
 * searchVideosクエリの引数のうち、配列型であるもののリスト
 */
export const ARRAY_VALUE_FIELDS: ReadonlyArray<keyof SearchVideosQueryVariables> = [
  "categories",
  "genres",
  "casts",
  "staffs",
  "viewingTypes",
  "campaigns",
];

export const URL_QUERY_TO_QUERY_VARIABLES_MAP = {
  categories: "categories",
  genres: "genres",
  series: "series",
  casts: "casts",
  staffs: "staffs",
  content_types: "contentType",
  viewing_types: "viewingTypes",
  keyword: "keyword",
  sort: "sort",
  cursor: "after",
  campaigns: "campaigns",
} as { readonly [K in keyof SearchVideoUrlQuery]: keyof SearchVideosQueryVariables };

export const SEARCH_FACET_TO_URL_QUERY_MAP = {
  categories: "categories",
  genres: "genres",
  series: "series",
  casts: "casts",
  staffs: "staffs",
  contentTypes: "content_types",
  viewingTypes: "viewing_types",
  campaigns: "campaigns",
} as { readonly [K in SearchFacetType]: keyof SearchVideoUrlQueryForMetaTitle };

/**
 * MEMO(uchida): グラビアのFacet情報
 * 作品一覧の絞り込み条件にハードコードで追加するために使用
 */
export const GRAVURE_FACET_ITEM: Readonly<FacetItem> = {
  name: "グラビア",
  value: CATEGORY_IDS.GRAVURE,
  count: 0, // ヒット数はわからないので0とする
};
